export const css = {
	root: 'PL0PX_43',
	toolbar: '_3AQBbj4m',
	alphabutton: '_3vaEjBNS',
	numberbutton: 'h10tm2UT',
	searchinput: '_1nKzVsm8',
	selectedbutton: 'KN8To5yj',
	invalidbutton: 'mnftsFBB',
	result: '_8ybjwUfy',
	terms: '_2IdXNUyM',
	term: '_2gIzgW9q',
	definition: '_3FPDNmbU',
	' _key': 'afcpe-theme/afcpe/glossary/glossary'
};

export default css;
